<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div class="modal-body">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold"
          v-text="'Edit Document'"
        />
      </header>
      <div class="mt-4">
        <label
          for="document-title"
          v-text="'Title'"
        />
        <input
          id="document-title"
          v-model="name"
          type="text"
          name="document-title"
          class="input"
          placeholder="Title"
        >
      </div>
    </div>
    <div class="flex justify-center items-baseline modal-footer text-center mt-4">
      <button
        type="button"
        class="btn"
        @click="save"
        v-text="'Save'"
      />
      <a
        href="#"
        class="mx-4"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'EditDocumentModal',
  data() {
    return {
      name: '',
    }
  },
  computed: {
    show() {
      return this.$store.state.document.editDocumentModal.open
    },
    document() {
      return this.$store.state.document.editDocumentModal.document
    },
  },
  watch: {
    document() {
      if (this.document) {
        this.name = this.document.attributes.title
      }
    },
  },
  methods: {
    save() {
      if (!this.name) {
        return
      }

      this.$api.active().put(`documents/${this.document.uuid}`, {
        name: this.name,
      }).then(() => {
        this.$emit('documentHasBeenUpdated')

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Document updated!',
        })

        this.close()
      })
    },
    close() {
      this.$store.commit('documentCloseEditDocumentModal')
    },
  },
}
</script>
